export const Cultures = {
    tr: 'tr-TR',
    en: 'en-US',
    fr: 'fr-FR',
    ge: 'gr-GR',
    es: 'es-ES'
}
